export default __webpack_public_path__ + "static/media/shipping.e3d598b4.png";